module.exports = "https://la-static.vkplay.ru/promo/newstart/img/intro-bg.878f8465.jpg";